import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import DrawerWrapper from '../../../ui/modules/DrawerWrapper'
import ActivateReturn from '../../../ui/modules/ReturnDrawer/ActivateReturn'
import SuccessFeedback from '../../../ui/modules/ReturnDrawer/SuccessFeedback'
import {
  useShippingReturnDeliveredMutation,
  useShippingReturnMutation,
} from '../../../services/shippingReturn'
import { SHIPPING_STATUS_CODES } from '../../../common/constants'
const ActivateReturnDrawer = ({
  activateReturnShippingInfo,
  onClickClose,
  onClickShowReturnsList,
}) => {
  const intl = useIntl()
  const confirmMutation = useShippingReturnMutation()
  const confirmDeliveredMutation = useShippingReturnDeliveredMutation()
  
  useEffect(() => {
    if (
      confirmMutation.variables?.shippingCode !== undefined &&
      confirmMutation.variables?.shippingCode !==
        activateReturnShippingInfo?.shippingCode
    ) {
      confirmMutation.reset()
    }

    if (
      confirmDeliveredMutation.variables?.shippingCode !== undefined &&
      confirmDeliveredMutation.variables?.shippingCode !==
        activateReturnShippingInfo?.shippingCode
    ) {
      confirmDeliveredMutation.reset()
    }
  }, [confirmMutation, confirmDeliveredMutation, activateReturnShippingInfo])

  const handleConfirm = async (status, phone, email ) => {
    if (SHIPPING_STATUS_CODES.delivered === status)
      await confirmDeliveredMutation.mutateAsync({
        shippingCode: activateReturnShippingInfo?.shippingCode,
        phone: phone ?? null, 
        email: email ?? null,

      })
    else {
      await confirmMutation.mutateAsync({
        shippingCode: activateReturnShippingInfo?.shippingCode,
      })
    }
  }

  const renderActivateInfo = () => {
    if (!!activateReturnShippingInfo) {
      const returnName = activateReturnShippingInfo.recipientName

      const returnAddress = []
      if (activateReturnShippingInfo.recipientAddress) {
        returnAddress.push(activateReturnShippingInfo.recipientAddress)
      }
      if (activateReturnShippingInfo.recipientAddress2) {
        returnAddress.push(activateReturnShippingInfo.recipientAddress2)
      }
      if (activateReturnShippingInfo.destinPostalCode) {
        returnAddress.push(activateReturnShippingInfo.destinPostalCode)
      }
      if (activateReturnShippingInfo.destinCountryCode) {
        returnAddress.push(
          intl.formatDisplayName(activateReturnShippingInfo.destinCountryCode, {
            type: 'region',
          }),
        )
      }

      return (
        <ActivateReturn
          returnName={returnName}
          returnAddress={returnAddress.join(', ')}
          returnShipping={activateReturnShippingInfo}
          isLoading={confirmMutation.isLoading || confirmDeliveredMutation.isLoading}
          onClickClose={onClickClose}
          onClickConfirm={handleConfirm}
        />
      )
    } else {
      return null
    }
  }

  const renderSuccessInfo = () => {
    return (
      <SuccessFeedback
        returnNumber={
          confirmMutation?.data?.data?.shippingCode ??
          confirmDeliveredMutation?.data?.data?.shippingCode
        }
        //CAMBIAR CUANDO SE VUELVA A PONER QUE VAYA A LA PANTALLA DE SEGUIMIENTODE DEVOLUCIONES
        onClickShowReturnsList={onClickClose}
      />
    )
  }

  return (
    <DrawerWrapper isOpen={!!activateReturnShippingInfo} onClose={onClickClose}>
      <>
        {confirmMutation.data?.data.shippingCode ||
        confirmDeliveredMutation.data?.data.shippingCode
          ? renderSuccessInfo()
          : renderActivateInfo()}
      </>
    </DrawerWrapper>
  )
}

ActivateReturnDrawer.propTypes = {
  activateReturnShippingInfo: PropTypes.shape({
    shippingCode: PropTypes.string,
    recipientName: PropTypes.string,
    recipientAddress: PropTypes.string,
    recipientAddress2: PropTypes.string,
    destinCountryCode: PropTypes.string,
    destinPostalCode: PropTypes.string,
    senderMail: PropTypes.string,
  }),
  onClickClose: PropTypes.func,
  onClickShowReturnsList: PropTypes.func,
}

export default ActivateReturnDrawer
